import React from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";


const TogetherForTheFutureSection = ({}) => {

    return (
        <div className="my-5 py-5 bg-dark-img">
            <div className="container">
                <div className='row'>
                    <div className='col-5'></div>
                    <div className='col-7 color-white bg-dark font-etihad translate-dynamic'>
                        <h3 className="font-bold color-white">Together for the future</h3>
                        <p>Etihad is committed to achieving high standards of sustainability, aligned with global frameworks and the goals of the United Arab Emirates. Aiming to continually demonstrate excellence in sustainability under the banner of the UAE, Etihad proudly represents the Emirate of Abu Dhabi.</p>
                        <p>Learn more about our <a className="font-bold color-white underline" target="_blank" href="https://www.etihad.com/en-ae/sustainability">approach to sustainability</a>.</p>
                    </div>
                </div>
            </div>
        </div>
    )
}


export default TogetherForTheFutureSection;